import { clone } from '@/common/js/just.js'
import { datetimeToSec } from '@/common/js/filters.js'

const active_call_rule = {
  active: '用户激活时',
  role: '用户创角时'
}

const regist_call_rule = {
  regist: '用户注册时',
  role: '用户创角时'
}
const pay_call_rule = {
  pay: '每次付费时',
  first_pay: '首次付费时',
  create_role_in_2h: '创建角色2小时内'
}
const event_call_rule = {
  first_pay: '首次付费时',
  create_role_in_2h: '创建角色2小时内'
}
const numberMap = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九',
  10: '十'
}
const reportTypeMap = {
  1: '无条件',
  2: '指定条件'
}
const callbackTypeMap = {
  1: '全部上报',
  2: '全部禁报',
  3: '随机上报',
  4: '循环上报'
}

export const amountEnum = {
  ORIGINAL_AMOUNT: 1,
  FIXED_AMOUNT: 2,
  COEFFICIENT_AMOUNT: 3,
  RANDOM_AMOUNT: 4
}
const moneyTypeMap = {
  [amountEnum.ORIGINAL_AMOUNT]: '原始金额',
  [amountEnum.FIXED_AMOUNT]: '固定金额',
  [amountEnum.COEFFICIENT_AMOUNT]: '系数金额',
  [amountEnum.RANDOM_AMOUNT]: '随机金额'
}

export const OPERATOR_TYPE_LIST = [
  {
    label: '大于等于',
    value: '>='
  },
  {
    label: '等于',
    value: '='
  },
  {
    label: '小于等于',
    value: '<='
  },
  {
    label: '小于',
    value: '<'
  },
  {
    label: '不等于',
    value: '≠'
  }
]

export const WECHAT_PAY_OPERATOR_TYPE_LIST = [
  {
    label: '等于',
    value: '='
  }
]

export const CONDITION_TYPE = {
  wechatPayType: 'wechatPayType',
  createRoleTimeDiff: 'createRoleTimeDiff',
  gamePayCount: 'gamePayCount',
  orderMoney: 'orderMoney',
  maxRoleLevel: 'maxRoleLevel',
  adAmount: 'adAmount',
  adNewPayCost: 'adNewPayCost',
  adPayCountCost: 'adPayCountCost',
  adNewPayCountCost: 'adNewPayCountCost',
  adAmount7d: 'adAmount7d',
  adNewPayCost7d: 'adNewPayCost7d',
  adPayCountCost7d: 'adPayCountCost7d',
  gamePaySum: 'gamePaySum',
  gameAmount: 'gameAmount',
  gameCallbackPayCost: 'gameCallbackPayCost',
  gameCallbackPayCountCost: 'gameCallbackPayCountCost',
  gameCallbackSumMoney: 'gameCallbackSumMoney',
  gameCallbackRoi: 'gameCallbackRoi',
  gameCallbackPayCost7d: 'gameCallbackPayCost7d',
  gameCallbackPayCountCost7d: 'gameCallbackPayCountCost7d',
  gameCallbackSumMoney7d: 'gameCallbackSumMoney7d',
  gameCallbackRoi7d: 'gameCallbackRoi7d',
  gameAmount7d: 'gameAmount7d'
}

export const CONDITION_TYPE_OPTS = [
  {
    label: '用户支付平台',
    value: CONDITION_TYPE.wechatPayType
  },
  {
    label: '支付创角时间差',
    value: CONDITION_TYPE.createRoleTimeDiff
  },
  {
    label: '创角用户累计付费次数',
    value: CONDITION_TYPE.gamePayCount
  },
  {
    label: '单次付费金额',
    value: CONDITION_TYPE.orderMoney
  },
  {
    label: '创角用户最高等级',
    value: CONDITION_TYPE.maxRoleLevel
  },
  {
    label: '首日计划消耗金额',
    value: CONDITION_TYPE.adAmount
  },
  {
    label: '首日计划付费成本',
    value: CONDITION_TYPE.adNewPayCost
  },
  {
    label: '首日计划每次付费成本',
    value: CONDITION_TYPE.adPayCountCost
  },
  {
    label: '首日计划新创角每次付费成本',
    value: CONDITION_TYPE.adNewPayCountCost
  },
  {
    label: '近7日计划消耗金额',
    value: CONDITION_TYPE.adAmount7d
  },
  {
    label: '近7日计划付费成本',
    value: CONDITION_TYPE.adNewPayCost7d
  },
  {
    label: '近7日计划每次付费成本',
    value: CONDITION_TYPE.adPayCountCost7d
  },
  {
    label: '创角用户累计付费金额',
    value: CONDITION_TYPE.gamePaySum
  },
  {
    label: '首日包体消耗',
    value: CONDITION_TYPE.gameAmount,
    withMedia: true
  },
  {
    label: '首日包体回调付费成本',
    value: CONDITION_TYPE.gameCallbackPayCost,
    withMedia: true
  },
  {
    label: '首日包体回调每次付费成本',
    value: CONDITION_TYPE.gameCallbackPayCountCost,
    withMedia: true
  },
  {
    label: '首日包体回调付费金额',
    value: CONDITION_TYPE.gameCallbackSumMoney,
    withMedia: true
  },
  {
    label: '首日包体回调付费ROI',
    value: CONDITION_TYPE.gameCallbackRoi,
    withMedia: true
  },
  {
    label: '近7日包体回调付费成本',
    value: CONDITION_TYPE.gameCallbackPayCost7d,
    withMedia: true
  },
  {
    label: '近7日包体回调每次付费成本',
    value: CONDITION_TYPE.gameCallbackPayCountCost7d,
    withMedia: true
  },
  {
    label: '近7日包体回调付费金额',
    value: CONDITION_TYPE.gameCallbackSumMoney7d,
    withMedia: true
  },
  {
    label: '近7日包体回调付费ROI',
    value: CONDITION_TYPE.gameCallbackRoi7d,
    withMedia: true
  },

  {
    label: '近7日包体消耗',
    value: CONDITION_TYPE.gameAmount7d,
    withMedia: true
  }
]

/**
 * @description: 用户支付平台下拉列表
 * @return {*}
 */
export const WECHAT_PAY_TYPE_OPTS = [
  {
    label: '全部',
    value: -1
  },
  {
    label: '小程序IOS支付',
    value: 2
  },
  {
    label: '小程序安卓支付',
    value: 1
  }
]

/**
 * @description: 支付创角时间差下拉列表
 * @return {*}
 */
export const CREATE_ROLE_TIME_DIFF_OPTS = [
  {
    label: '24小时',
    value: 24
  },
  {
    label: '1天',
    value: 1
  },
  {
    label: '2天',
    value: 2
  },
  {
    label: '3天',
    value: 3
  },
  {
    label: '4天',
    value: 4
  },
  {
    label: '5天',
    value: 5
  },
  {
    label: '6天',
    value: 6
  },
  {
    label: '7天',
    value: 7
  }
]

export const withMediaKeys = CONDITION_TYPE_OPTS.filter((i) => i.withMedia).map((i) => i.value)

export default class DataReports {
  /**
   * @description: 数据上报类型
   * @enum 1 异常管控
   * @enum 2 数据上报
   */
  static DATA_TYPES = {
    EXCEPTION: 1,
    REPORT: 2
  }

  static DATA_TYPE_LIST = [
    { label: '异常管控', value: this.DATA_TYPES.EXCEPTION },
    { label: '数据上报', value: this.DATA_TYPES.REPORT }
  ]

  /**
   * @description: 游戏类型
   * @return {*}
   */
  static GAME_TYPES = {
    MIDDLEWARE: 1,
    GROUP: 2,
    GAME: 3
  }

  static GAME_TYPE_LIST = [
    { label: '中间件游戏', value: this.GAME_TYPES.MIDDLEWARE, key: 'mgameIds' },
    { label: '游戏组', value: this.GAME_TYPES.GROUP, key: 'gameGroupIds' },
    { label: '游戏', value: this.GAME_TYPES.GAME, key: 'gameIds' }
  ]

  /**
   * @description: 媒体类型
   * @return {*}
   */
  static MEDIA_TYPES = {
    MEDIA: 2
  }

  static MEDIA_TYPE_LIST = [{ label: '媒体', value: this.MEDIA_TYPES.MEDIA, key: 'mediaIds' }]

  /**
   * @description: 账号类型
   */
  static ACCOUNT_TYPES = {
    ACCOUNT: 2
  }

  static ACCOUNT_TYPE_LIST = [{ label: '账号', value: this.ACCOUNT_TYPES.ACCOUNT, key: 'accountIds' }]

  /**
   * @description: 日志状态
   */
  static LOG_STATES = ['不回调', '待回调', '回调成功', '回调失败', '禁止上报']
  /**
   * @description: 日志查询事件类型下拉列表
   */
  static LOG_STATES_LIST = [
    { label: '回调成功', value: 2 },
    { label: '禁止上报', value: 4 },
    { label: '回调失败', value: 3 }
  ]

  /**
   * @description: 日志查询事件类型下拉列表
   */
  static CALL_TYPE_LIST = [
    { label: '激活', value: 1 },
    { label: '注册', value: 2 },
    { label: '登录', value: 3 },
    { label: '创角', value: 4 },
    { label: '付费', value: 5 },
    { label: '关键行为', value: 10 }
  ]

  static defaultForm = {
    ruleName: '',
    controlType: this.DATA_TYPES.EXCEPTION,
    gameType: this.GAME_TYPES.MIDDLEWARE,
    mgameIds: [], // 中间件
    gameGroupIds: [], // 游戏组
    gameIds: [], // 游戏
    mediaType: 1,
    mediaIds: [], // 媒体
    accountType: 1,
    accountIds: [], // 账号
    exceptionConfig: {
      role_level: '',
      first_order_money: ''
    },
    reportConfig: {
      active_call_check: true,
      regist_call_check: false,
      pay_call_check: false,
      event_call_check: false,
      active_call: {
        event: 'active'
      },
      regist_call: {
        event: ''
      },
      pay_call: {
        event: '',
        ext: {
          role_level: '',
          money: ''
        },
        report_condition: 1, // 1全部条件，2指定条件
        settings: [this.getDefaultSettings()]
      },
      event_call: {
        event: '',
        ext: {
          role_level: ''
        }
      }
    }
  }

  static getDefaultSettings() {
    return {
      order: 1, // 阶梯序号
      relation_type: 1, // (1 是且, 2 是或),如果只有一个条件是1
      conditions: [
        {
          condition_type: '',
          operator_type: '',
          limit_current_media: '',
          value: ''
        }
      ],
      callback_type: 1,
      callback_rate: '',
      recyle_offset: '',
      recyle_interval: '',
      money_type: amountEnum.ORIGINAL_AMOUNT,
      money_value: ''
    }
  }

  /**
   * @description: 获取配置参数字段
   * @param {*} config
   * @return {*}
   */
  static getConfigForm() {
    return clone(this.defaultForm)
  }

  /**
   * @description: 编辑时需要传入config参数
   * @param {*} config
   * @return {*}
   */
  static makeModifyConifgForm(config) {
    const { accountIds, mediaIds, gameGroupIds, mgameIds, gameIds, ruleConfig } = config

    const configForm = {
      ...clone(this.defaultForm),
      ruleId: config.ruleId,
      status: config.status,
      opId: config.opId
    }

    configForm.ruleName = config.ruleName
    configForm.controlType = config.controlType

    if (accountIds) {
      configForm.accountIds = accountIds.split(',').map((id) => Number(id))
      configForm.accountType = this.ACCOUNT_TYPES.ACCOUNT
    }

    if (mediaIds) {
      configForm.mediaIds = mediaIds.split(',').map((id) => Number(id))
      configForm.mediaType = this.MEDIA_TYPES.MEDIA
    }

    if (gameGroupIds) {
      configForm.gameGroupIds = gameGroupIds.split(',').map((id) => Number(id))
    }

    if (mgameIds) {
      configForm.mgameIds = mgameIds.split(',').map((id) => Number(id))
    }

    if (gameIds) {
      configForm.gameIds = gameIds.split(',').map((id) => Number(id))
    }

    const ruleConfigJson = JSON.parse(ruleConfig)

    if (config.controlType === DataReports.DATA_TYPES.EXCEPTION) {
      const { role_level, first_order_money } = ruleConfigJson
      configForm.exceptionConfig = { role_level, first_order_money }
    }

    if (config.controlType === DataReports.DATA_TYPES.REPORT) {
      const { active_call, regist_call, pay_call, event_call } = ruleConfigJson

      configForm.reportConfig = {
        ...configForm.reportConfig,
        ...ruleConfigJson,
        // 根据参数，判断是否需要勾选
        active_call_check: !!active_call,
        regist_call_check: !!regist_call,
        pay_call_check: !!pay_call,
        event_call_check: !!event_call
      }

      if (pay_call) {
        const { ext, settings, report_condition } = pay_call
        // 判断是否需要追加附加参数
        if (!ext) {
          pay_call.ext = this.defaultForm.reportConfig.pay_call.ext
        }
        if (!settings) {
          pay_call.settings = this.defaultForm.reportConfig.pay_call.settings
        }
        if (!report_condition) {
          pay_call.report_condition = this.defaultForm.reportConfig.pay_call.report_condition
        }
        configForm.reportConfig.pay_call = pay_call
      }

      if (event_call) {
        const { ext } = event_call
        // 判断是否需要追加附加参数
        if (!ext) {
          event_call.ext = this.defaultForm.reportConfig.event_call.ext
        }
        configForm.reportConfig.event_call = event_call
      }
    }

    return configForm
  }

  /**
   * @description: 获取数据上报类型
   * @param {*} cellValue
   * @return {*}
   */
  static getControlType(cellValue) {
    return this.DATA_TYPE_LIST.find((item) => item.value === cellValue).label || '-'
  }

  /**
   * @description: 转换游戏名称及分组
   * @param {*} row
   * @return {*}
   */
  static getGameNames(row) {
    const gameRows = []
    const { openGameGroupInfos, mGames, openGameInfos } = row

    if (openGameGroupInfos?.length) {
      const groupStr = openGameGroupInfos.map((g) => g.groupName).join(',')
      gameRows.push(`游戏组：${groupStr};`)
    }

    if (mGames?.length) {
      const gameStr = mGames.map((g) => g.gameName).join(',')
      gameRows.push(`中间件：${gameStr};`)
    }

    if (openGameInfos?.length) {
      const gameStr = openGameInfos.map((g) => g.gameName).join(',')
      gameRows.push(`单游戏：${gameStr};`)
    }

    return gameRows.join('<br/>')
  }

  /**
   * @description: 解析配置规则
   * @param {*} cellValue
   * @param {*} row
   * @return {*}
   */
  static getConfigRules(cellValue, row) {
    const { controlType } = row
    let config = {}
    try {
      config = JSON.parse(cellValue)
      // 异常管控
      if (controlType === 1) {
        const { first_order_money, role_level } = config || {}
        if (!first_order_money) return '-'
        return `${role_level}级以内，首笔金额小于等于${first_order_money}元不上报`
      }

      // 数据上报
      if (controlType === 2) {
        const ruleRows = []
        const { active_call, event_call, pay_call, regist_call } = config || {}

        if (active_call) {
          ruleRows.push(`激活行为上报-${active_call_rule[active_call.event]}；`)
        }

        if (regist_call) {
          ruleRows.push(`注册行为上报-${regist_call_rule[regist_call.event]}；`)
        }

        if (pay_call) {
          const settings = pay_call.settings || []
          if (settings && settings.length) {
            const report_condition = pay_call.report_condition
            const payStr = `付费行为上报，上报条件-${reportTypeMap[report_condition]}；`
            ruleRows.push(payStr)
            for (let index = 0; index < settings.length; index++) {
              const setting = settings[index]
              const { callback_type, callback_rate, money_type, money_value, recyle_offset, recyle_interval } = setting
              let ladder_text = report_condition === 2 ? `阶梯${numberMap[index + 1]}：` : ''
              ladder_text += `上报方式-${callbackTypeMap[callback_type]}`
              switch (callback_type) {
                case 3:
                  ladder_text += `-${callback_rate}%`
                  break
                case 4:
                  ladder_text += `-上报${recyle_offset}笔后，不上报${recyle_interval}笔`
                  break
              }
              ladder_text += '，'
              ladder_text += `上报金额-${moneyTypeMap[money_type]}`
              switch (money_type) {
                case amountEnum.FIXED_AMOUNT:
                  ladder_text += `${money_value}元；`
                  break
                case amountEnum.COEFFICIENT_AMOUNT:
                  ladder_text += `${money_value}%；`
                  break
                case amountEnum.RANDOM_AMOUNT:
                  ladder_text += `（${money_value}）元；`
                  break
              }
              ruleRows.push(ladder_text)
            }
          } else {
            ruleRows.push(`付费行为上报-${pay_call_rule[pay_call.event]}`)
          }
        }

        if (event_call) {
          let eventStr = `关键行为上报-${event_call_rule[event_call.event]}；`
          const { role_level } = event_call.ext || {}
          if (role_level) {
            eventStr += `升到等级${role_level}时上报`
          }
          ruleRows.push(eventStr)
        }

        return ruleRows.join('<br/>')
      }
    } catch (e) {
      return '上报规则解析错误'
    }
  }

  /**
   * @description: 获取数据上报任务列表
   * @return {*}
   */
  static getGridOptions() {
    return {
      border: true,
      showHeaderOverflow: true,
      // showOverflow: 'tooltip',
      columnConfig: {
        resizable: true
      },
      data: [],
      height: 500,
      columns: [
        { title: '开关', width: 70, slots: { default: 'switch' } },
        { field: 'ruleId', title: '任务id', width: 70 },
        { field: 'ruleName', title: '任务名称', width: 190 },
        { field: 'mediaNames', title: '媒体', showOverflow: 'tooltip', width: 120 },
        { field: 'accountNames', title: '账号', showOverflow: 'tooltip', width: 120 },
        {
          field: 'games',
          title: '游戏',
          type: 'html',
          width: 300,
          formatter: ({ row }) => DataReports.getGameNames(row)
        },
        { field: 'controlType', title: '类型', width: 80, formatter: ({ cellValue }) => DataReports.getControlType(cellValue) },
        {
          field: 'ruleConfig',
          title: '规则内容',
          type: 'html',
          formatter: ({ cellValue, row }) => DataReports.getConfigRules(cellValue, row)
        },
        { field: 'createOpName', title: '新建人', width: 100 },
        {
          field: 'createTime',
          title: '新建时间',
          width: 140,
          showOverflow: 'tooltip',
          formatter: ({ cellValue }) => datetimeToSec(cellValue)
        },
        { field: 'updateOpName', title: '更新人', width: 100 },
        { field: 'upTime', title: '更新时间', width: 140, showOverflow: 'tooltip', formatter: ({ cellValue }) => datetimeToSec(cellValue) },
        { title: '操作', width: 120, fixed: 'right', slots: { default: 'operation' } }
      ]
    }
  }

  /**
   * @description: 表单校验
   * @return {*}
   */
  static makeConfigFormValidRules() {
    return {
      ruleName: [
        { required: true, message: '请输入任务名称', trigger: 'blur' },
        { min: 2, max: 50, message: '名称长度在2~50个字符', trigger: 'blur' }
      ],
      game: [{ required: true, validator: validateGame.bind(this), trigger: 'change' }],
      exceptionRule: [{ required: true, validator: validateExceptionRule.bind(this), trigger: 'change' }],
      reportingActiveRule: [{ required: true, validator: validateReportingActiveRule.bind(this), trigger: 'change' }],
      reportingRegRule: [{ validator: validateReportingRegRule.bind(this) }],
      reportingPayRule: [{ validator: validateReportingPayRule.bind(this) }],
      reportingPayRuleRate: [{ validator: validateReportingPayRuleRate.bind(this) }],
      reportingPayRuleMoney: [{ validator: validateReportingPayRuleMoney.bind(this) }],
      reportingEventRule: [{ validator: validateReportingEventRule.bind(this) }]
    }
  }

  /**
   * @description: 获取数据上报任务日志表格
   * @return {*}
   */
  static getGridLogOptions() {
    return {
      border: true,
      showHeaderOverflow: true,
      // showOverflow: 'tooltip',
      columnConfig: {
        resizable: true
      },
      data: [],
      height: 500,
      columns: [
        {
          field: 'addTime',
          title: '时间',
          width: 140,
          showOverflow: 'tooltip',
          formatter: ({ cellValue }) => datetimeToSec(cellValue)
        },
        { field: 'mediaName', title: '媒体', width: 70 },
        { field: 'planName', title: '计划名称', width: 130 },
        { field: 'adAccountName', title: '账号', width: 80 },
        { field: 'callTypeDesc', title: '事件类型', width: 90 },
        {
          field: 'sendType',
          title: '状态',
          width: 70,
          formatter: ({ cellValue }) => this.LOG_STATES[cellValue]
        },
        { field: 'userName', title: '用户名称', width: 110, showOverflow: 'tooltip' },
        { field: 'userId', title: '用户', width: 100 },
        { field: 'serverName', title: '区服', width: 110, showOverflow: 'tooltip' },
        { field: 'roleLevel', title: '等级', width: 70 },
        { field: 'orderMoney', title: '原订单金额', width: 90 },
        { field: 'money', title: '上报金额', width: 70 },
        { field: 'ruleTypeDesc', title: '规则类型', width: 100, showOverflow: 'tooltip' },
        {
          field: 'ruleDesc',
          title: '规则内容',
          type: 'html',
          showOverflow: 'tooltip',
          formatter: ({ cellValue }) => cellValue.replace(/\n/g, '；')
        },
        { field: 'deviceNo', title: '设备号', width: 240, showOverflow: 'tooltip' }
      ]
    }
  }
}
// 1-9999整数
const intRegExp = /^[1-9][0-9]{0,3}$/
// 1-99999整数
export const int59RegExp = /^[1-9][0-9]{0,4}$/
export const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
function validateGame(rule, value, callback) {
  const { mgameIds, gameGroupIds, gameIds } = this.configForm
  if (!mgameIds.length && !gameGroupIds.length && !gameIds.length) {
    return callback(new Error('请至少选择一个游戏'))
  }
  callback()
}

function validateExceptionRule(rule, value, callback) {
  const { exceptionConfig } = this.configForm

  const { role_level, first_order_money } = exceptionConfig

  if (!role_level) {
    return callback(new Error('请输入角色等级'))
  }
  if (!intRegExp.test(role_level)) {
    return callback(new Error('用户等级请输入1~9999正整数'))
  }
  if (!intRegExp.test(first_order_money)) {
    return callback(new Error('充值金额请输入1~9999正整数'))
  }
  callback()
}

/**
 * @description: 校验激活行为
 * @return {*}
 */
function validateReportingActiveRule(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { active_call_check, regist_call_check, pay_call_check, event_call_check, active_call } = reportConfig

  if (!active_call_check && !regist_call_check && !pay_call_check && !event_call_check) {
    return callback(new Error('请至少选择一条上报规则'))
  }

  if (active_call_check && !active_call.event) {
    return callback(new Error('请选择激活行为的上报事件'))
  }

  callback()
}

/**
 * @description: 校验注册行为
 * @return {*}
 */
function validateReportingRegRule(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { regist_call, regist_call_check } = reportConfig
  if (regist_call_check && !regist_call.event) {
    return callback(new Error('请选择注册行为的上报事件'))
  }
  callback()
}

/**
 * @description: 校验付费行为
 * @return {*}
 */
function validateReportingPayRule(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { pay_call_check, pay_call } = reportConfig

  if (pay_call_check) {
    if (!pay_call.event) {
      return callback(new Error('请选择付费行为的上报事件'))
    }

    if (pay_call.event === 'create_role_in_2h') {
      // 当选中 [付费行为上报] 且是 [创角2小时内升到等级] 类型时，校验输入等级及金额
      const { role_level, money } = pay_call.ext || {}

      if (!role_level) {
        return callback(new Error('请输入角色等级'))
      }

      if (!intRegExp.test(role_level)) {
        return callback(new Error('用户等级请输入1~9999正整数'))
      }

      if (!intRegExp.test(money)) {
        return callback(new Error('充值金额请输入1~9999正整数'))
      }
    }
  }

  callback()
}

/**
 * @description: 校验付费行为-上报方式
 * @return {*}
 */
function validateReportingPayRuleRate(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { pay_call_check, pay_call } = reportConfig

  if (pay_call_check) {
    const settings = pay_call.settings || []

    for (let index = 0; index < settings.length; index++) {
      const { callback_type, callback_rate, recyle_offset, recyle_interval } = settings[index] || {}
      if (callback_type === 3) {
        if (!intRegExp.test(callback_rate)) {
          return callback(new Error('上报比例请输入1~9999正整数'))
        }
      }
      if (callback_type === 4) {
        if (!intRegExp.test(recyle_offset) || !intRegExp.test(recyle_interval)) {
          return callback(new Error('循环上报设置上报笔数请输入1~9999正整数'))
        }
      }
    }
  }

  callback()
}

/**
 * @description: 校验付费行为-上报方式
 * @return {*}
 */
function validateReportingPayRuleMoney(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { pay_call_check, pay_call } = reportConfig

  if (pay_call_check) {
    const settings = pay_call.settings || []
    for (let index = 0; index < settings.length; index++) {
      const { money_type, money_value } = settings[index] || {}
      if (money_type !== amountEnum.ORIGINAL_AMOUNT) {
        if (!money_value) {
          return callback(new Error('请输入金额'))
        }
      }
      if ([amountEnum.FIXED_AMOUNT, amountEnum.COEFFICIENT_AMOUNT].includes(money_type)) {
        if (!int59RegExp.test(money_value)) {
          return callback(new Error('金额请输入1~99999正整数'))
        }
      }
      if (money_type === amountEnum.RANDOM_AMOUNT) {
        const moneys = money_value.split(',')
        for (const money_val of moneys) {
          if (!int59RegExp.test(money_val)) {
            return callback(new Error('随机金额逗号分隔的每一项请输入1~99999正整数'))
          }
        }
      }
    }
  }

  callback()
}

/**
 * @description: 校验关键行为
 * @return {*}
 */
function validateReportingEventRule(rule, value, callback) {
  const { reportConfig } = this.configForm
  const { event_call_check, event_call } = reportConfig

  if (event_call_check) {
    if (!event_call.event) {
      return callback(new Error('请选择关键行为的上报事件'))
    }
    if (event_call.event === 'create_role_in_2h') {
      // 当选中 [关键行为上报] 且是 [创角2小时内升到等级] 类型时，校验输入等级及金额
      const { role_level } = event_call.ext

      if (!role_level) {
        return callback(new Error('请输入角色等级'))
      }

      if (!intRegExp.test(role_level)) {
        return callback(new Error('用户等级请输入1~9999正整数'))
      }
    }
  }

  callback()
}
